import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
  addColor,
  getSingleColor,
  updateColor,
} from "../../../actions/homeAction";

const ColorAdd = () => {
  const [color, setColor] = useState({
    color: "",
    colorAr: "",
    priority: null,
    active: true,
  });

  const [dataEdit, setDataEdit] = useState(false);
  const { clUUID } = useParams();

  const dispatch = useDispatch();

  const location = window.location.href.split("/")[6];
  useEffect(() => {
    if (location === "Update") {
      dispatch(getSingleColor(clUUID));
      setDataEdit(true);
    } else {
      setDataEdit(false);
    }
  }, []);

  const singleColor = useSelector((state) => state.home.singleColor)?.response;
  const data = singleColor;

  useEffect(() => {
    setColor({
      color: data?.color,
      colorAr: data?.colorAr,
      priority: data?.priority,
      active: data?.active === 0 ? "false" : "true",
    });
  }, [data?.color]);

  console.log("color", clUUID);
  const onChangeHandle = (e) => {
    const { name, value } = e.target;
    setColor({ ...color, [name]: value });
  };

  const onSave = () => {
    if (dataEdit) {
      const payload = {
        color: color.color,
        colorAr: color.colorAr,
        priority: color.priority,
        active: color.active,
        colorId: data.colorId,
      };
      dispatch(updateColor(payload));
    } else {
      dispatch(addColor(color));
    }
  };

  return (
    <div className="main-body">
      <div className="page-wrapper">
        <div className="page-header">
          <div className="row align-items-end">
            <div className="col-lg-8">
              <div className="page-header-title">
                <div className="d-inline">
                  <h4>{dataEdit ? `Edit : ${data?.color}` : "Add Color"}</h4>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="page-header-breadcrumb">
                <ul className="breadcrumb-title">
                  <li className="breadcrumb-item">
                    <Link to="/">
                      <i className="feather icon-home"></i>{" "}
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/CarDetail/Color">Color</Link>
                  </li>
                  <li className="breadcrumb-item active">
                    {dataEdit ? "Edit Color:" : "Add Color"}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="page-body">
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-border-default">
                <div className="card-block">
                  <div className="tab-content tabs">
                    <div
                      className="tab-pane  active"
                      id={"car_user_"}
                      role="tabpanel"
                      aria-labelledby=""
                    >
                      <div className="">
                        <div className="col-md-6"></div>

                        {/* sdjkfj */}
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">
                                  Color Name
                                </label>
                                <div className="col-sm-9">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="color"
                                    value={color.color}
                                    placeholder="Color Name"
                                    onChange={onChangeHandle}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">
                                  Color Name Ar
                                </label>
                                <div className="col-sm-9">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="colorAr"
                                    value={color.colorAr}
                                    placeholder="Color Name Ar"
                                    onChange={onChangeHandle}
                                  />
                                </div>
                              </div>
                            </div>

                              <div className='col-md-6'>
                              <div className='form-group row'>
                                <label className='col-sm-3 col-form-label'>Priority</label>
                                <div className='col-sm-9'>
                                  <input
                                    type='number'
                                    className='form-control'
                                    name='priority'
                                    value={color.priority}
                                    placeholder='Priority'
                                    onChange={onChangeHandle}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">
                                  Status
                                </label>
                                <div className="col-sm-9">
                                  <select
                                    name="active"
                                    className="form-control"
                                    onChange={onChangeHandle}
                                    value={color?.status}
                                  >
                                    <option value={true} name="active">
                                      Active
                                    </option>
                                    <option value={false} name="inactive">
                                      Inactive
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card-footer">
                            <div className="row float-right p-3">
                              <button
                                onClick={onSave}
                                className="btn btn-grd-disabled mr-2"
                              >
                                <i className="icofont icofont-save"></i>
                                {dataEdit ? "Update" : "Add"}
                              </button>
                              <Link
                                to={"/CarDetail/Color"}
                                className="btn btn-outline-dark"
                              >
                                {" "}
                                Cancel{" "}
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColorAdd;
